<div class="h-screen">
    <app-header *ngIf="isLoggedIn && !isLoginRoute"></app-header>
    <router-outlet></router-outlet>
</div>